import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import stateMap from "store/stateMap";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { popinfo } from "component/Fancybox/Fancybox";
import { useSearchParams, createSearchParams, useNavigate, useLocation, Link } from "react-router-dom";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import EditPageForm from "component/EditPage";
import {InitiativeList} from "component/InitiativeList";
import { useParams } from "react-router-dom";
import "./style.scss";
import api from "api";
import fancybox from "component/Fancybox/Fancybox";
import _ from "lodash";
import { parsePath } from "react-router-dom";
import ThreeDots from "component/ThreeDots";
import PaginationWrapper from "component/Pagination";
import update from "immutability-helper";
import ComponentPageLike from "component/PageLike";
import { PageCredential } from "component/PageCredential";

const PagePagesInside = (props) => {
    
    let navigate                                = useNavigate();
    const [page, setPage]                       = useState(false);
    const [initiativeLoad, setInitiativeLoad]   = useState(false);
    const [initiatives, setInitiatives]         = useState([]);
    const [initiativeCount, setInitiativeCount] = useState(false);
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 9
    });
    let {page_slug}           = useParams();

    useEffect(() => {
        if(page === false)
        {
            api('/Pages', 'get', {
                slug : page_slug 
            }, props.auth.user ? 'Bearer ' + props.auth.token : '')
                .then(response => {
                    setPage(response.page[0]);
                })
                .catch(response => {
                    setPage(null);
                })
        
        }

    }, [props.auth.user, parameter]);

    const loadInitiative = () => {

        if(page === false || page === null)
        {
            return;
        }

        var DataToLoad = [
            api('/initiative', 'get', _.assign({related_page : page.PageID}, parameter))
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/initiative', 'get', _.assign({get_total : 1, related_page : page.PageID}, parameter))
            );
        }

        setInitiativeLoad(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setInitiatives(response[0].initiative);

                setInitiativeLoad(false);

                if(parameter.paged === 1)
                {
                    setInitiativeCount( parseInt(response[1].initiative) );
                }

            })
            .catch((error) => {
                setInitiativeLoad(false);
                
            })
    }
    
    useEffect(loadInitiative, [page, parameter]);

    return (
        <>
            <Header/>
                <PageCredential title={`${page.PageName}`} />
                <div className="page-container">
                    <div className="page-header-part">
                        <div className="container relative">
                            <div className="page-image">
                                <span className="image-box square w-100 mx-auto rounded border-solid" style={{width : '100px'}}>
                                    {
                                        page !== false && <img src={page.PagePhoto}></img>
                                    }
                                </span>
                            </div>
                            <div className="part-title">
                                {
                                    page === false ? <span className="skeleton"></span> :
                                    <BlockHeader title={page.PageName} />
                                }
                                <div className="">
                                    <ComponentPageLike page={page} />
                                </div>
                                <div className="mt-4">
                                    {
                                        page === false ? <><span className="skeleton"></span><br/><span className="skeleton"></span></>  :
                                        <div className="leading-text w-800" dangerouslySetInnerHTML={{__html : page.PageDesc}}></div>
                                    }
                                </div>
                                
                            </div>
                            {
                                page && page.HasAdminAccess &&
                                <ThreeDots>
                                    <button onClick={ e => {
                                        e.preventDefault();

                                        const PageForm = fancybox(
                                            <div className="w-640">
                                                <BlockHeader title="Manage Page" desc="" className="mb-sm"/>
                                                <EditPageForm page={page} onSave={savedPage => {
                                                    if(page.PageSlug != savedPage.PageSlug)
                                                    {
                                                        navigate({
                                                            pathname    : '/page/' + savedPage.PageSlug  
                                                        });
                                                    }
                                                    else
                                                    {
                                                        savedPage.HasAdminAccess = true;

                                                        setPage(savedPage)
                                                    }
                            
                                                    PageForm.close();
                                                }}/>
                                            </div>
                                        );

                                    }}>Manage</button>
                                    <button onClick={ e => {
                                        e.preventDefault();

                                        var ask = window.confirm('Are You Sure ?');

                                        if(!ask)
                                        {
                                            return;
                                        }

                                        let RemovePages = popinfo('loading', 'Delete Page', '');

                                        api('/Pages', 'delete', {
                                            page_id : page.PageID
                                        }, 'Bearer ' + props.auth.token)
                                            .then(() => {
                                                RemovePages.close();

                                                navigate({ pathname    : '/' });
                                            })   
                                            .catch(error => {
                                                popinfo('error', 'Removing Skill', error, {}, RemovePages);
                                            })

                                    }}>Delete</button>
                                </ThreeDots>
                            }
                        </div>
                    </div>
                    <div className="page-initiatives container">
                        <div className="relative">
                            <BlockHeader title="Initiatives" desc={`List of initiatives in ${page.PageName}`} />
                            {
                                !initiativeLoad && 
                                <>
                                    {
                                        page && page.HasAdminAccess &&
                                        <Link className="btn btn-reverse absolute btn-small" to="/create" style={{right : 0, top : 0, position : 'absolute'}}>Add Initiative</Link>
                                    }
                                    <InitiativeList initiatives={initiatives}/>
                                    <PaginationWrapper
                                        className="mt-4"
                                        activePage={parameter.paged}
                                        itemsCountPerPage={parameter.posts_per_page}
                                        totalItemsCount={initiativeCount}
                                        pageRangeDisplayed={5}
                                        onChange={(pagenumber) => {
                                            setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                        }}
                                    />
                                </>
                            }
                        </div>
                    </div>
                </div> 
            <Footer/>
        </>
    )
}

export default connect(stateMap)(PagePagesInside);